module.exports = __webpack_public_path__ + "static/media/Ultrasonido.5607c430.svg";